<template>
	<div class="open-account-bank">
		
		<van-nav-bar :title="translate('account_hkbank_title')" fixed />
		
		<van-form @submit="nextStep()" :label-width="100">

			<h4 class="h4_title">{{ translate('account_hkbank_subtitle_1') }}</h4>

			<van-field 
				v-model="formItem.country" 
				:label="translate('country')" 
				:placeholder="translate('please_input')"
				:rules="rules.country"
				required
			/>
			
			<van-field 
				v-model="formItem.bank" 
				:label="translate('bank')" 
				:placeholder="translate('please_input')"
				:rules="rules.bank"
				required
			/>

			<van-field 
				v-model="formItem.bank_address" 
				:label="translate('bank_address')" 
				:placeholder="translate('please_input')"
				:rules="rules.bank_address"
				required
			/>
			<van-field 
				v-model="formItem.account_name" 
				:label="translate('account_name')" 
				:placeholder="translate('please_input')"
				:rules="rules.account_name"
				required
			/>
			<van-field 
				v-model="formItem.account_no" 
				:label="translate('bank_number')" 
				:placeholder="translate('please_input')"
				:rules="rules.account_no"
				required
			/>
			<van-field
				v-model="formItem.account_address" 
				:label="translate('account_address')" 
				:placeholder="translate('please_input')"
				:rules="rules.account_address"
				required
			/>

			<van-field
				v-model="formItem.swift_code"
				label="SWIFT CODE"
				:placeholder="translate('please_input')"
				:rules="rules.swift_code"
				required
			/>
			
			<div class="submit-button">
				<van-button type="warning" block round color="#224A9F" native-type="submit">{{ translate('next_step') }}</van-button>
			</div>
		</van-form>
	
	</div>
</template>

<script>

	export default {
		name: 'account_hkbank',
		data() {

			let translate = this.translate

			return {
				formItem: {
					country: "",
					bank: "",
					bank_address: "",
					account_name: "",
					account_no: "",
					account_address: "",
					swift_code: "",
				},

				rules: {
					country: [
						{
							required: true,
							message: translate('please_input') + translate('country'),
							trigger: 'onBlur'
						}
					],
					bank: [
						{
							required: true,
							message: translate('please_input') + translate('bank'),
							trigger: 'onBlur'
						}
					],
					bank_address: [
						{
							required: true,
							message: translate('please_input') + translate('bank_address'),
							trigger: 'onBlur'
						}
					],
					account_name: [
						{
							required: true,
							message: translate('please_input') + translate('account_name'),
							trigger: 'onBlur'
						}
					],
					account_no: [
						{
							required: true,
							message: translate('please_input') + translate('bank_number'),
							trigger: 'onBlur'
						}
					],
					account_address: [
						{
							required: true,
							message: translate('please_input') + translate('account_address'),
							trigger: 'onBlur'
						}
					],
					swift_code: [
						{
							required: true,
							message: translate('please_input') + 'SWIFT CODE',
							trigger: 'onBlur'
						}
					],
				},

				token: "",
				
				resourceURL: this.$axios.defaults.resourceURL,
				
				disabledSubmit: true,
				
			}
		},
		mounted() {
			
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			} else {
				this.token = this.$route.query.token
				
				this.init()
			}
		},
		methods: {
			init(){
				
				this.$axios({
					method: 'post',
					url: 'account_open/info',
					data: {
						token: this.token
					}
				}).then ((res) => {
					if (res.success) {

						if (res.data.status == 2) {
							//	待审核
							this.$router.replace('/account/success')
						} else if (res.data.status == 3) {
							//	不通过
							this.$router.replace('/account/fail?token=' + this.token)
						} else {
							
							var abroad_data = res.data.abroad_data		
							
							if (abroad_data.length != 0) {
								this.formItem.country = abroad_data.country ? abroad_data.country : ""
								this.formItem.bank = abroad_data.bank ? abroad_data.bank : ""
								this.formItem.bank_address = abroad_data.bank_address ? abroad_data.bank_address : ""
								this.formItem.account_name = abroad_data.account_name ? abroad_data.account_name : ""
								this.formItem.account_no = abroad_data.account_no ? abroad_data.account_no : ""
								this.formItem.account_address = abroad_data.account_address ? abroad_data.account_address : ""
								this.formItem.swift_code = abroad_data.swift_code ? abroad_data.swift_code : ""
								
							}

						}

						
					}else{
						this.$toast.fail(res.error_text)
					}
				})

				
			},

			nextStep(){

				this.$axios({
					method: 'post',
					url: 'account_open/update',
					data: {
						token: this.token,
						abroad_data: JSON.stringify(this.formItem)
					}
				}).then ((res) => {
					if (res.success) {
						this.$router.push('/account/success')
					}else{
						this.$toast.fail(res.error_text)
					}
				})
				
			}
		},
	}
</script>